import React from 'react';
import PropTypes from 'prop-types';
import css from './KioskError.scss';
import { showStudentDashboard, landingPageForVirtualKiosk } from 'utils/kiosk';
import { getWord } from 'utils/tenant';
import { SFEntityID } from 'utils/types';

// Error page for the Virtual kiosk workflow.
// Example: Student signing into a service that requires referral, invalid bookmarked virtual kiosk being launched.
const KioskError = ({ error, studentId }) => {
    return (
        <div className={css['container']}>
           <img src={'../images/starfish/starfish_error2.png'} />
            <div className={css['error-header']}>Oops! Something went wrong...</div>
            <div className={css['message']}>
                { error && error }
                { !error && `The page you are looking for is no longer available or you may not have permission to access it.`}
                { studentId && <p>Please return to {getWord("Starfish")} and try again.</p> }
            </div>
            { studentId &&
                <a className={css['go-back']} href={landingPageForVirtualKiosk()}>
                    Go to {showStudentDashboard() ? 'Dashboard' : getWord("successNetwork", false)}
                </a>
            }
       </div>
    );
}

KioskError.propTypes = {
    error: PropTypes.string,
    studentId: SFEntityID
}

export default KioskError;
